export const locale = {
  iVolView: 'Chart by IVolatility.com'
};
